/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Button, InputGroup, Row, Col,
  Card, CardBody, CardHeader,
} from 'reactstrap';

import BaseGrid from '../Common/BaseGrid';
import { get, post } from '../../helpers/api_helper';

function TVTruckManifest(props) {
  const {
    t, truck, onStage,
  } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [lanesData, setLanesData] = useState([]);
  const [selectedLane, setSelectedLane] = useState(null);

  useEffect(() => {
    const loadLanes = async () => {
      try {
        const response = await get('/api/tvs/pallets/lanes');
        setLanesData(response);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    };

    loadLanes();
  }, []);

  const stageLane = async () => {
    try {
      await post(`/api/tvs/pallets/stage/${truck.id}?lane=${selectedLane}`);
      toastr.success(t('Lane staged'), t('Success'));
      onStage();
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const downloadStagedManifest = async () => {
    try {
      const response = await get(`/api/tvs/pallets/staged-manifest/${truck.id}`);
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `staged_manifest_${truck.reference}.csv`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const jsx = (
    <Card>
      <CardHeader className="bg-transparent border-bottom">
        {t('TV Lane Staging')}
      </CardHeader>
      <CardBody>
        <div className="mb-4">
          <Row>
            <Col sm="8">
              <InputGroup>
                <select className="form-control" onChange={(e) => { setSelectedLane(e.target.value); }} style={{ width: '200px' }}>
                  <option value="">{t('Select Lane')}</option>
                  {lanesData.map((lane) => (
                    <option key={lane.lane} value={lane.lane}>{`${lane.lane} - (${lane.qty} pallets)`}</option>
                  ))}
                </select>
                <Button color="primary" className="btn-soft-primary" onClick={stageLane}>
                  <span className="mdi mdi-truck" />
                  {' '}
                  {t('Stage Lane')}
                </Button>
              </InputGroup>
            </Col>

            <Col sm="4">
              {truck && truck.staged_lanes !== null && (
              <Button color="primary" className="btn-soft-primary" onClick={downloadStagedManifest}>
                <span className="mdi mdi-download" />
                {' '}
                {t('Download Staged Manifest')}
              </Button>
              )}
            </Col>
          </Row>
        </div>

        <BaseGrid
          url="/api/tvs/pallets"
          hasSearch
          filters={`lane=${selectedLane !== null ? selectedLane : ''}`}
          config={
          {
            columns: {
              id: {
                label: 'ID',
                sort: true,
                link: {
                  to: '/tvs/pallets/%id%',
                },
                format: (v) => v.toString(36).toUpperCase(),
              },
              class: {
                label: 'Classification',
                sort: true,
                style: { textTransform: 'capitalize', fontSize: '19px', fontWeight: 'bold' },
              },
              lane: {
                label: 'Lane',
                sort: true,
                format: (value) => {
                  if (value) {
                    return `${value}`;
                  }
                  return t('not tracked');
                },
              },
              truck: {
                label: 'Truck',
                sort: true,
                html: true,
                format: (value) => {
                  if (value) {
                    return `${value.supplier ? value.supplier.name : 'NA'}: <a href="/sourcing/truck/${value.id}">${value.reference}</a>`;
                  }
                  return t('not loaded');
                },
              },
            },
            pagination: {
              sort: 'id',
              direction: 'desc',
              perPage: 10,
            },
          }
          }
        />
      </CardBody>
    </Card>
  );

  return jsx;
}

TVTruckManifest.defaultProps = {
  truck: {},
  onStage: () => {},
};

TVTruckManifest.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  truck: PropTypes.object,
  onStage: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(TVTruckManifest));
